import { render } from "./VideoWeChatMiniappIntroduce.vue?vue&type=template&id=ac0d32a4&scoped=true"
import script from "./VideoWeChatMiniappIntroduce.vue?vue&type=script&lang=js"
export * from "./VideoWeChatMiniappIntroduce.vue?vue&type=script&lang=js"

import "./VideoWeChatMiniappIntroduce.vue?vue&type=style&index=0&id=ac0d32a4&lang=scss&scoped=true"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0d32a4"]])

export default __exports__